import React, { Component } from 'react'
import { connect } from 'react-redux'
import GoogleMap from 'components/common/Maps/Map'
import { setMapPosition } from 'reducers/seaLice/reducer'
import PolygonList from './MarkerList/BarrioPolygonList'
import MapLoader from './MapManipulation/BarrioSitesMapLoader'

const MapRef = React.createRef()

class BarriosMap extends Component {
  constructor(props) {
    super(props)
    this.mapChangeTimeout = null
  }

  shouldComponentUpdate(nextProps) {
    return this.props.mapPosition === nextProps.mapPosition
  }

  onMapPositionChanged = () => {
    clearTimeout(this.mapChangeTimeout)
    this.mapChangeTimeout = setTimeout(this.saveMapPosition, 500)
  }

  saveMapPosition = () => {
    if (MapRef.current !== null) {
      this.props.setMapPosition({
        mapZoom: MapRef.current.getZoom(),
        mapCenter: MapRef.current.getCenter().toJSON(),
      })
    }
  }

  render() {
    const { mapPosition, hiddenBarrioTooltip } = this.props
    const mapZoom = mapPosition ? mapPosition.get('mapZoom') : undefined
    const mapCenter = mapPosition ? mapPosition.get('mapCenter') : undefined

    return (
      <div className="map-container">
        <GoogleMap
          mapRef={MapRef}
          mapZoom={mapZoom}
          mapCenter={mapCenter}
          onCenterChanged={this.onMapPositionChanged}
          onZoomChanged={this.onMapPositionChanged}>
          <PolygonList hiddenBarrioTooltip={hiddenBarrioTooltip} />
        </GoogleMap>
        <MapLoader mapRef={MapRef} />
      </div>
    )
  }
}

export default connect(
  state => ({
    mapPosition: state.getIn(['seaLice', 'mapPosition']),
  }),
  { setMapPosition },
)(BarriosMap)
